import * as angular from "angular";

export class ServiceAnalysisRequestsService {

  /* @ngInject */
  constructor(private ServiceAnalysisApi, private $serviceAnalysis) {
  }

  getGeneratingRoutes(branchId?) {
    const api = this.ServiceAnalysisApi.actions.getGeneratingRoutes;
    return this.$$call(api, {isDone: false, branchId: branchId}, {}, {})
  }

  getGeneratingProcess(id) {
    const api = this.ServiceAnalysisApi.actions.getGeneratingProcess;
    return this.$$call(api, {}, {}, {id: id})
  }

  cancelGeneratingRoutes() {
    var api = this.ServiceAnalysisApi.actions.cancelGeneratingRoutes;
    return this.$$call(api, {isDone: false}, {}, {})
  }

  cancelGeneratingRouteById(id) {
    var api = this.ServiceAnalysisApi.actions.cancelGeneratingRouteById;
    return this.$$call(api, {}, {}, {id: id})
  }

  $$call(_apiCall, _params, _data, _options) {
    return this.$serviceAnalysis().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.service-analysis')
  .service('serviceAnalysisRequestsService', ServiceAnalysisRequestsService);
